export default __webpack_public_path__ + "static/media/nike.1d01a6ba.png";